<template>
  <div class="sitesearch">
    <div
      v-if="showSearchInput && (showFilters || showOtherSearchServices || showFlerFilters)"
      class="searcheader"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col col-md-10 col-xxl-8 p-md-0">
            <SearchForm
              :baseApiUrl="suggestApiUrl"
              :texts="texts"
              :suggestSokOptions="sokOptions"
              :idString="'searchInput'"
              :selectedFilter="searchType"
              :selectedFacets="selectedFacets"
              :sokFilter="sokFilter"
              :sokFacets="sokFacets"
              :showFilters="showFilters"
              :showFlerFilters="showFlerFilters"
              @filterSelected="filterSelected"
              @facetSelected="facetSelected"
            ></SearchForm>
            <OtherSearchServices
              v-if="otherSearchServices && otherSearchServices.length > 0"
              :searchServices="otherSearchServices"
              :texts="texts"
            ></OtherSearchServices>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="showSearchInput" class="searchinput">
      <SearchForm
        :baseApiUrl="suggestApiUrl"
        :texts="texts"
        :suggestSokOptions="sokOptions"
        :idString="'searchInput'"
        :selectedFilter="''"
        :selectedFacets="selectedFacets"
        :sokFilter="[]"
        :sokFacets="sokFacets"
        :showAnswer="showAnswer"
      ></SearchForm>
    </div>
    <div class="searchresult">
      <SearchResult
        v-if="searchResultHits !== undefined"
        :searchResultHits="searchResultHits"
        :totalMatchingText="totalMatchingText"
        :texts="texts"
        :showAnswer="showAnswer"
        :sokOptions="sokOptions"
        :query="query"
        :searchType="searchType"
        :showBreadcrumb="showBreadcrumb"
      ></SearchResult>
      <Pagination
        v-if="
          searchResultHits &&
          searchResultHits.length > 0 &&
          totalMatching > 10 &&
          !showAnswer
        "
        :totalMatching="totalMatching"
        :url="paginationUrl"
        :labels="texts"
        @changePage="onChangePage"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import sitesearchservice from "../plugins/sitesearchservice";
import SearchResult from "./components/searchresult.vue";
import Pagination from "../pagination/pagination.vue";
import SearchForm from "./components/searchform.vue";
import OtherSearchServices from "./components/othersearchservices.vue";
import SearchFacets from "./components/searchfacets.vue";
import Sok from "common/js/script/sok";

export default {
  name: "SiteSearch",
  props: {
    baseApiUrl: String,
    siteLang: String,
    texts: Object,
    showAnswer: Boolean,
    showSearchInput: Boolean,
    suggestApiUrl: String,
    showBreadcrumb: Boolean,
    sokFilter: Array,
    otherSearchServices: Array,
    take: {
      type: Number,
      default: 10,
    },
  },
  data: function () {
    return {
      query: "",
      searchType: "",
      showFilters: false,
      showFlerFilters: false,
      showOtherSearchServices: false,
      sokOptions: null,
      searchResultHits: undefined,
      sokFacets: undefined,
      totalMatching: 0,
      totalMatchingText: "",
      paginationTexts: undefined,
      paginationUrl: "",
      page: 1,
      selectedFacets: {
        studieortkod: [],  //TODO, take from facett?
        starttermin: [],
        studietakt: [],
        undervisningsformkod: [],
        undervisningssprakkod: [],
        contentlabel: [],
        utb_utbildningsnivakod: [],
      },
    };
  },
  created() {
    if (this.sokFilter?.length > 0) {
      this.$.appContext.app.config.globalProperties = {
        $baseApiUrl: this.baseApiUrl,
        $siteLang: this.siteLang,
      };

      const urlParams = new URLSearchParams(window.location.search);
      this.showFilters = this.sokFilter.length > 1;
      this.showOtherSearchServices = this.otherSearchServices.length > 0;
      this.query = this.getValueFromUrlParams(urlParams, "q");
      this.searchType = this.getValueFromUrlParams(urlParams, "filter");    
      this.sokOptions = this.setSearchOptions();
      this.handleFacetFromUrl(urlParams);  

      if (this.sokOptions?.Filters) {        
        const tillfalleFilters = this.sokOptions.Filters.find((f) => f.Type === 4);
        if (tillfalleFilters) {
          this.showFlerFilters = true
        }    
      }
      this.paginationUrl = this.setPaginationUrl();
      this.page = this.getValueFromUrlParams(urlParams, "page", true);
      this.getResult();
    }
  },
  components: {
    SearchResult,
    Pagination,
    SearchForm,
    OtherSearchServices,
    SearchFacets,
  },
  methods: {
    setSearchOptions() {
      if (this.searchType != "") {
        var filterMatch = this.sokFilter.find(
          (f) => f.type === this.searchType
        );
        if (filterMatch) {
          this.searchType = filterMatch.type;
          return filterMatch.sokOptions;
        }
      } else {
        var allt = this.sokFilter.find((f) => f.type === "allt");
        if (allt) {
          this.searchType = allt.type;
          return allt.sokOptions;
        }
      }

      if (this.sokOptions == null) {
        this.searchType = this.sokFilter[0].type;
        return this.sokFilter[0].sokOptions;
      }
    },
    setPaginationUrl() {
      if (this.searchType != "") {
        this.paginationUrl = `?q=${this.query}&filter=${this.searchType}&page=`;
      } else {
        this.paginationUrl = `?q=${this.query}&page=`;
      }
    },
    getResult() {
      let skip = (this.page - 1) * this.take;
      this.sokOptions.Skip = skip.toString();
      this.sokOptions.Take = this.take.toString();
      this.sokOptions.Query = this.query;

      sitesearchservice
        .getResult(this.$baseApiUrl, this.sokOptions)
        .then((result) => {
          if (result && result.status === 200) {
            this.searchResultHits = result.data.hits?.map(hit => {
              if (hit.url?.includes('www.umu') && window.location.hostname.includes('www2.umu')) {
                // We are on the www2 site, so we need to change the url to www2
                return {
                  ...hit,
                  url: hit.url.replace('www.umu', 'www2.umu')
                };
              }
              return hit;
            });
            this.totalMatching = result.data.totalMatching;
            this.sokFacets = result.data.facets;

            if (this.totalMatching > 0) {
              let start = (this.page - 1) * this.take + 1;
              let end =
                this.page * this.take <= this.totalMatching
                  ? this.page * this.take
                  : this.totalMatching;

              this.totalMatchingText = `${this.texts.visar} ${start}-${end} ${this.texts.av} ${this.totalMatching} ${this.texts.resultat}`;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getValueFromUrlParams(urlParams, param, int = false) {
      if (int) {
        return urlParams.has(param) ? parseInt(urlParams.get(param)) : 1;
      }
      return urlParams.has(param) ? urlParams.get(param) : "";
    },
    handleFacetFromUrl(urlParams) {
      for (const key in this.selectedFacets) {
        const urlParamName = Sok.generateUrlParamName(key);
        const urlParamValue = this.getValueFromUrlParams(urlParams, urlParamName);
        if (urlParamValue.length > 0 && this.sokOptions?.Filters) {
          const facetFilter = this.sokOptions.Filters.find((f) => f.Name === key);
          if (facetFilter) {
            facetFilter.Value = urlParamValue;
            this.selectedFacets[key] = urlParamValue.split(",");
          }
        }
      }
    },
    clearFacet(urlParams) {
      for (const key in this.selectedFacets) {
        const urlParamName = Sok.generateUrlParamName(key);
        if (urlParams.has(urlParamName)) {
          urlParams.delete(urlParamName);
          this.selectedFacets[key] =  [];
          const facetFilter = this.sokOptions.Filters.find((f) => f.Name === key);
          if (facetFilter) {
            facetFilter.Value = "";
          }
        }
      }
    },
    onChangePage(page) {
      this.page = page;
      this.getResult();
      document.getElementById("searchresulttotal").focus();
    },
    filterSelected(selected) { 
      this.searchResultHits = [];
      this.page = 1;
      this.searchType = selected;

      const urlParams = new URLSearchParams(window.location.search);
      // Set new or modify existing parameter value.
      urlParams.set("filter", selected);

      if (urlParams.has("page")) {
        urlParams.delete("page");
      }
      if (urlParams.has("facet")) {
        //Workaround for something that should not be there.
        urlParams.delete("facet");
      }
      this.clearFacet(urlParams);
      this.sokOptions = this.setSearchOptions();
      this.paginationUrl = this.setPaginationUrl();
      this.getResult(1);

      // Replace current querystring with the new one.
      history.replaceState(null, null, "?" + urlParams.toString());
    },
    facetSelected(selected, facetnamn) { 
      const urlParamName = Sok.generateUrlParamName(facetnamn);
      this.searchResultHits = [];
      this.page = 1;
      this.sokOptions = this.setSearchOptions();
      this.sokOptions.Filters.find((f) => f.Name === facetnamn).Value = selected.join(",");
      this.paginationUrl = this.setPaginationUrl();
      this.getResult(1);

      const urlParams = new URLSearchParams(window.location.search);
      // Set new or modify existing parameter value.
      urlParams.set(urlParamName, selected);

      if (urlParams.has("page")) {
        urlParams.delete("page");
      }

      if (urlParams.has("facet")) {
        //Workaround for something that should not be there.
        urlParams.delete("facet");
      }

      // Replace current querystring with the new one.
      history.replaceState(null, null, "?" + urlParams.toString());
    },
  },
};
</script>